export default __webpack_public_path__ + "static/media/smart-home-wifi.9c1c356c.svg";